/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @date    15/4/19
 * @since   1.0.0
 *
 * @param   object $block The block jQuery element.
 * @param   object attributes The block attributes (only available when editing).
 * @return  void
 */
var initializeBlock = function ( $block ) {

    $block.find("header").click(function () {

      $('.open').not(this).find('.open-accordion-icon').toggleClass('hidden');
      $('.open').not(this).find('.closed-accordion-icon').toggleClass('hidden');

      $('.open').not(this).removeClass('open').next().hide(300);

        $(this).toggleClass('open');

        // Current header
        $(this).find('.open-accordion-icon').toggleClass('hidden');
        $(this).find('.closed-accordion-icon').toggleClass('hidden');
        if (false == $(this).next().is(':visible')) {
            $('.accordion > .accordion-content').slideUp(300);
        }
        $(this).next().slideToggle(300);
    });

}

// Initialize each block on page load (front end).
$(document).ready(function () {
    $('.accordion').each(function () {
        initializeBlock($(this));
    });
});

// Initialize dynamic block preview (editor).
if ( window.acf ) {
    window.acf.addAction('render_block_preview/type=slider', initializeBlock);
}
